import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import styles from './Wordmark.module.scss';

export interface IWordmarkProps {
  className?: string;
  onNavigate?: () => void;
}

export default function Wordmark({ className, onNavigate }: IWordmarkProps) {
  return (
    <NavLink
      end
      to="/"
      className={clsx(styles.wordmark, className)}
      onClick={onNavigate}
      aria-label="My TXT home"
    >
      <span className={styles.my}>My </span>
      <span className={styles.txt}>TXT</span>
    </NavLink>
  );
}
